/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pHeadBtns.vue?vue&type=template&id=6a78e1ce&scoped=true"
import script from "./pHeadBtns.vue?vue&type=script&lang=js"
export * from "./pHeadBtns.vue?vue&type=script&lang=js"
import style0 from "./pHeadBtns.vue?vue&type=style&index=0&id=6a78e1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a78e1ce",
  null
  
)

export default component.exports